import InputUtp1 from "./InputPle";

export default [
    InputUtp1,
]
